import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchStatuses } from '../api/statuses';

/**
 * Pipeline statuses — rarely change, long staleTime.
 */
export function useStatuses () {
  return useQuery({
    queryKey: queryKeys.statuses.all,
    queryFn: fetchStatuses,
    staleTime: 5 * 60_000,
  });
}
